var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveproject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.6496C10.69 19.6496 10.39 19.6096 10.14 19.5196C6.32 18.2096 0.25 13.5596 0.25 6.68961C0.25 3.18961 3.08 0.349609 6.56 0.349609C8.25 0.349609 9.83 1.00961 11 2.18961C12.17 1.00961 13.75 0.349609 15.44 0.349609C18.92 0.349609 21.75 3.19961 21.75 6.68961C21.75 13.5696 15.68 18.2096 11.86 19.5196C11.61 19.6096 11.31 19.6496 11 19.6496ZM6.56 1.84961C3.91 1.84961 1.75 4.01961 1.75 6.68961C1.75 13.5196 8.32 17.3196 10.63 18.1096C10.81 18.1696 11.2 18.1696 11.38 18.1096C13.68 17.3196 20.26 13.5296 20.26 6.68961C20.26 4.01961 18.1 1.84961 15.45 1.84961C13.93 1.84961 12.52 2.55961 11.61 3.78961C11.33 4.16961 10.69 4.16961 10.41 3.78961C9.48 2.54961 8.08 1.84961 6.56 1.84961Z",
    fill: "url(#paint0_linear_2694_805)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2694_805",
    x1: 11,
    y1: 0.349609,
    x2: 11,
    y2: 19.6496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57200",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F0CA18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveproject);
export default __webpack_public_path__ + "static/media/saveproject.4d7b4dba7ac93b298e550ee9a3f992c1.svg";
export { ForwardRef as ReactComponent };